export default "__VITE_ASSET__CCMPITxI__"